"use client";
import React from "react";

import { getLoginInfoApi, outLoginToC } from "@/apis/login/login.api";

interface loginParams {
  returnUrl?: string
}

export default class NewJDILogin {
  isOpenLogin = null;
  constructor() {
    this.root = document.createElement("div");
    document.body.appendChild(this.root);
    this.forgetPsdRef = React.createRef(); // 通过ref
    this.userInfoPromise = null; // 用户信息
    this.props = {
      handleClose: () => {
        const that = this;
        that.isOpenLogin = false;
      },
    };
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new NewJDILogin();
    }
    return this.instance;
  }

  jumpToLoginPage(params: loginParams = {}) {
    const { returnUrl = location.href } = params;
    location.href = `/login?returnUrl=${encodeURIComponent(returnUrl)}`;
  }

  /**
   * @param callback 登录弹框回调函数
   * @param props 传入参数 isRefresh：传入false登陆成功后禁止刷新页面；
   */
  // 打开登录弹框
  async openLoginDialog(params: loginParams = {}) {
    const { returnUrl = location.href } = params;
    // 支持多站点登录态同步，这里不打开弹窗了，直接渲染登录页, 统一登录入口是com的登录页面
    location.href = `/login?returnUrl=${encodeURIComponent(returnUrl)}`;
  }

  // 判断是否登录, 如已登录则返回用户信息；
  async getUserInfo() {
    this.userInfoPromise = new Promise(async (resolve, reject) => {
      const [err, res] = await getLoginInfoApi({ types: [6] }, { meta: { forceIgnoreLogin: true } });
      if (err) {
        resolve({
          isLoggedIn: false,
          userInfo: null,
        });
        return;
      }

      if (res.success && res.data) {
        resolve({
          isLoggedIn: true,
          userInfo: res.data,
        });
      } else {
        resolve({
          isLoggedIn: false,
          userInfo: null,
        });
      }
    });
    return this.userInfoPromise;
  }
  
  // 退出登录
  async logOut() {
    try {
      const [err, res] = await outLoginToC();
      if (res && res.success) {
        // cookieUtils.deleteCookie(loginConfig.loginLocalInfo.USER_SUCCESS_ACCOUNT)
        window.JDIheader && window.JDIheader.initUserInfo();
        window.JDIheader && window.JDIheader.initCartNum();
        // handleAddressData("clear");
        location.reload();
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  }
}
